<template>
  <analytics-sub-page
    title="Pay Analytics"
    icon="money-bill-wave"
    css-class="analytics-pay"
    default-label="Pay"
    :section-specs="sectionSpecs"
  >
    <stream-metrics ref="streamRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import StreamMetrics, { streamMetricsSections } from '@/pages/analyticsApp/components/StreamMetrics.vue';

const streamRef = ref(null);

// StreamMetrics carves itself into three logical subsections (Users /
// Transfers / Transfer reasons). The section descriptors live with the
// component so this tab and the homepage "Download all" capture stay in sync.
const sectionSpecs = streamMetricsSections(streamRef);
</script>
